import { componentGeneratorTwo } from "../../Utils/ComponentGenerator";
import { useDispatch, useSelector } from "react-redux";
import "./Basiceditor.scss";
import Profile from "./Profile/Profile";
import Summary from "./Summary/Summary";
import Workexperience from "./Workexperience/Workexperience";
import Skill from "./Skill/Skill";

function Basiceditor({
  isMobile,
  resumeFields,
  resumeHandler,
  resumeUpdate,
  addResumeField,
  setResumeFields,
  resumeTitleHandler,
  handleEditorChange,
  resumeTitleRemove,
  dateHandler,
  deletePopupShow,
  languageHandler,
  contentAdder,
  resetImage,
  handleCustomDelete,
  handleItemDelete,
}) {
  const dispatch = useDispatch();

  const getSectionIndexBySectionId = (sectionId, sectionType) => {
    let data = { ...resumeFields, initialLoad: false };

    let componentArray = data.sectionPosition;
    if (componentArray && componentArray[sectionType]) {
      return componentArray[sectionType].findIndex((x) => x == sectionId);
    } else {
      return -1;
    }
  };

  const checkSectionPresentOrNot = (sectionId) => {
    let lsbarIndex = getSectionIndexBySectionId(sectionId, "lsbar");
    let rsbarIndex = getSectionIndexBySectionId(sectionId, "rsbar");

    if (lsbarIndex == -1 && rsbarIndex == -1) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <>
      <div className="row m-0">
        <div
          className="basiceditor"
          style={{
            width: "100%",
            margin: "0 auto",
            ...(isMobile ? { marginTop: "50px" } : {}),
          }}
        >
          <Profile
            sectionId="profile"
            resumeFields={resumeFields["profile"]}
            resumeHandler={resumeHandler}
            resumeUpdate={resumeUpdate}
            addResumeField={addResumeField}
            resumeAllFields={resumeFields}
            setResumeFields={setResumeFields}
            resetImage={resetImage}
            handleCustomDelete={handleCustomDelete}
          />

          <Summary
            sectionId="summary"
            resumeFields={resumeFields["summary"]}
            resumeHandler={resumeHandler}
            resumeUpdate={resumeUpdate}
            addResumeField={addResumeField}
            resumeAllFields={resumeFields}
            setResumeFields={setResumeFields}
            resumeTitleHandler={resumeTitleHandler}
            handleEditorChange={handleEditorChange}
            resumeTitleRemove={resumeTitleRemove}
            contentAdder={contentAdder}
          />
          {checkSectionPresentOrNot("experience") && (
            <Workexperience
              provided={"experience"}
              sectionId="experience"
              resumeFields={resumeFields["experience"]}
              resumeHandler={resumeHandler}
              resumeUpdate={resumeUpdate}
              addResumeField={addResumeField}
              resumeAllFields={resumeFields}
              setResumeFields={setResumeFields}
              resumeTitleHandler={resumeTitleHandler}
              handleEditorChange={handleEditorChange}
              resumeTitleRemove={resumeTitleRemove}
              dateHandler={dateHandler}
              deletePopupShow={deletePopupShow}
              contentAdder={contentAdder}
              handleItemDelete={handleItemDelete}
            />
          )}
          {checkSectionPresentOrNot("skills") && (
            <Skill
              provided={"skills"}
              sectionId="skills"
              resumeFields={resumeFields["skills"]}
              resumeHandler={resumeHandler}
              resumeUpdate={resumeUpdate}
              addResumeField={addResumeField}
              resumeAllFields={resumeFields}
              setResumeFields={setResumeFields}
              resumeTitleHandler={resumeTitleHandler}
              handleEditorChange={handleEditorChange}
              resumeTitleRemove={resumeTitleRemove}
              deletePopupShow={deletePopupShow}
              languageHandler={languageHandler}
              handleItemDelete={handleItemDelete}
            />
          )}
          {["lsbar", "rsbar"].map((position, index) => (
            <div className="row mt-4">
              {Array.isArray(
                resumeFields &&
                  resumeFields.sectionPosition &&
                  resumeFields.sectionPosition[position]
              ) && (
                <div className="col-md-12" key="lsbar">
                  {resumeFields &&
                    resumeFields.sectionPosition &&
                    resumeFields.sectionPosition[position] &&
                    resumeFields.sectionPosition[position].map((res, index) => {
                      return (
                        <div className=" ">
                          <div style={{ position: "relative" }}>
                            {componentGeneratorTwo(
                              res,
                              "basiceditor",
                              resumeFields[res],
                              resumeHandler,
                              resumeUpdate,
                              addResumeField,
                              resumeFields,
                              setResumeFields,
                              resumeTitleHandler,
                              handleEditorChange,
                              resumeTitleRemove,
                              dateHandler,
                              deletePopupShow,
                              languageHandler,
                              contentAdder,
                              handleItemDelete
                            )}
                          </div>
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Basiceditor;
